import { useContext } from 'react'

import AppContext from '@/common/context/app.context'

import UserInfo from './UserInfo/UserInfo'
import { getUserGroups } from './helpers'

const ProfileConfiguration = () => {
  const { info } = useContext(AppContext)

  const groups = getUserGroups(info?.userInfo?.stores)

  return (
    <UserInfo
      user={info?.userInfo}
      groups={groups}
      isOwner={info?.userInfo?.is_owner}
      storeId={info?.selectedStore?.id}
    />
  )
}

export default ProfileConfiguration
